module.exports = require("bluebird");


//////////////////
// WEBPACK FOOTER
// external "bluebird"
// module id = 2
// module chunks = 0